module.exports = __webpack_public_path__ + "images/emoji/heart_eyes.e09da47688d30de0b5df.png";